import { useContext } from 'react';

import { tripExtraContext } from './context';

export const useTripExtra = () => {
  const tripExtra = useContext(tripExtraContext);

  if (tripExtra === undefined) {
    throw new Error('useTripExtra must be called inside a TripExtraProvider');
  }

  return tripExtra;
};
